import Vue from 'vue';

// A tiny reactive channel between the Dashboard view (Home.vue) and the sidebar nav, so the
// layout controls can live in the nav menu instead of overlapping the dashboard panels.
// Home publishes state; the nav reads it and emits actions back.
const bus = new Vue({
	data() {
		return {
			active: false,        // true while the Dashboard view is mounted
			canEdit: false,       // desktop only — mobile is always the fixed default layout
			mode: 'default',      // 'default' (old layout) | 'custom' (editable grid)
			panels: [],           // [{ id, title, visible }] all panels + whether in the custom grid
		};
	},
});

export default bus;
